import React, { memo } from "react";
import FooterSection from "../Components/FooterSection";
import Header from '../Components/Header';
import InquiryFormData from "../Components/InquiryFormData";
import PageTitleSection from "../Components/PageTitleSection";
import Spacer from "../Components/Spacer";

const InquiryForm = (props) => {
    return (<>
        <Header />
        <PageTitleSection
            title="Inquiry  Form"
            pagetitle="Inquiry  Form"
            subtitle="Please fill the following details"
            bgImage="assets/images/pages/about-new-page.jpg"
        />
       
        <InquiryFormData {...props} showToast={props.showToast} />
        <Spacer bgClass="blackBg" />
        <FooterSection />
    </>)
}

export default memo(InquiryForm);